import { computeDepositPreview } from "../utils/pricingCalculations";

const PaymentRulesSection = ({
  paymentMode,
  onPaymentModeChange,
  partialAmount,
  onPartialAmountChange,
  paymentDays,
  onPaymentDaysChange,
  previewPrice,
}) => {
  const deposit = computeDepositPreview(
    previewPrice || 0,
    paymentMode === "full" ? 100 : partialAmount
  );

  return (
    <section className="rounded-xl border border-gray-100 bg-slate-50/40 p-5">
      <div className="mb-4">
        <h3 className="text-sm font-bold text-gray-900">Payment rules</h3>
        <p className="text-sm text-gray-500 mt-0.5">
          How customers pay when booking this package.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-4">
        <button
          type="button"
          onClick={() => onPaymentModeChange("full")}
          className={`p-3 rounded-xl border text-left transition-all ${
            paymentMode === "full"
              ? "border-primary/40 bg-primary/5"
              : "border-gray-100 bg-white hover:border-gray-200"
          }`}
        >
          <div className="text-sm font-semibold text-gray-800">Full payment</div>
          <div className="text-xs text-gray-500 mt-0.5">
            Customer pays 100% at booking
          </div>
        </button>
        <button
          type="button"
          onClick={() => onPaymentModeChange("partial")}
          className={`p-3 rounded-xl border text-left transition-all ${
            paymentMode === "partial"
              ? "border-primary/40 bg-primary/5"
              : "border-gray-100 bg-white hover:border-gray-200"
          }`}
        >
          <div className="text-sm font-semibold text-gray-800">Deposit</div>
          <div className="text-xs text-gray-500 mt-0.5">
            Partial now, balance before travel
          </div>
        </button>
      </div>

      {paymentMode === "partial" && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              Deposit %
            </label>
            <div className="relative">
              <input
                type="number"
                value={partialAmount}
                onChange={onPartialAmountChange}
                className="w-full h-10 border rounded-md px-3 pr-8 text-sm"
                placeholder="e.g. 30"
                min="1"
                max="99"
              />
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
                %
              </span>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1.5">
              Balance due (days before)
            </label>
            <input
              type="number"
              value={paymentDays}
              onChange={onPaymentDaysChange}
              className="w-full h-10 border rounded-md px-3 text-sm"
              placeholder="e.g. 7"
              min="0"
            />
          </div>
        </div>
      )}

      {previewPrice > 0 && (
        <div className="p-3 bg-gray-50 rounded-lg text-sm">
          <p className="text-gray-600">
            Example for ₹{previewPrice} adult price:
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
            <span>
              Pay now:{" "}
              <strong className="text-gray-800">₹{deposit.now}</strong>
            </span>
            {paymentMode === "partial" && (
              <span>
                Balance:{" "}
                <strong className="text-gray-800">₹{deposit.remaining}</strong>
                {paymentDays ? ` (${paymentDays} days before)` : ""}
              </span>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default PaymentRulesSection;
